// extracted by mini-css-extract-plugin
export default {"employee-container":"JobTitle_employee-container__fHKac"};